import React from 'react'
import styles from '../Styles/Mail.module.css'
import InputMail from '../../Includes/Input/InputMail'
import SelectMail from '../../Includes/Select/SelectMail'
import SelectCompanie from '../../Includes/Select/SelectCompanie'
import ButtonAddCircle from '../../Includes/Button/ButtonAddCircle'
import InputAutocomplete from '../../Includes/Input/InputAutocomplete'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Paper
} from '@mui/material'
import {
  CheckMail
} from '../../../Functions/Check'
import {
  ADD_MAIL,
  SET_MAIL,
  MAIL_ERROR
} from '../../../Redux/Actions/Mail'

const MailUsers = () => {
  const dispatch = useDispatch()
  const mail = useSelector(state => state.mail.mail)
  const error = useSelector(state => state.mail.error)
  const mails = useSelector(state => state.mail.mails)
  const users = useSelector(state => state.users.users)
  const select = useSelector(state => state.mail.select)
  const companie = useSelector(state => state.mail.companie)
  const utilisateurs = useSelector(state => state.mail.users)
  const liste = users.filter(item =>
    (item.archive === 0) &&
    (item.mail !== '')
  )
  const disabled = (
    (select === '') ||
    (
      (select === 3) &&
      (companie === '')
    ) ||
    (
      (select === 4) &&
      (utilisateurs.length === 0)
    ) ||
    (
      (select === 5) &&
      (
        (mail === '') ||
        (error.mail)
      )
    )
  )
  const Mail = (value) => {
    dispatch(SET_MAIL('mail', value))
    dispatch(MAIL_ERROR('mail', (
      (value !== '') &&
      (!CheckMail(value))
    )))
  }
  const Add = () => {
    if (!disabled) {
      dispatch(SET_MAIL('mail', ''))
      if (mails.indexOf(mail) < 0) {
        dispatch(ADD_MAIL(mail))
      }
    }
  }
  const Multiple = (array) => {
    dispatch(SET_MAIL('users', []))
    dispatch(SET_MAIL('mails', [
      ...mails,
      ...array.map(item => item.mail).filter(item => mails.indexOf(item) < 0)
    ]))
  }
  return (
    <Paper className={styles.paper}>
      <div className={styles.container}>
        <SelectMail
          data-testid="mail-destinataires-type"
          value={select}
          setValue={(value) => dispatch(SET_MAIL('select', value))}
        />
        <ButtonAddCircle
          data-testid="mail-destinataire-ajouter"
          disabled={disabled}
          className={styles.action}
          color={
            (disabled)
              ? "grey"
              : "blue"
          }
          onClick={() => {
            switch (select) {
              case 0:
                Multiple(liste.filter(item => item.gerant))
              break
              case 1:
                Multiple(liste.filter(item => item.profil === 'administrateur'))
              break
              case 2:
                Multiple(liste)
              break
              case 3:
                Multiple(liste.filter(item => item.unique_id_companie === companie))
              break
              case 4:
                Multiple(utilisateurs)
              break
              case 5:
                Add()
              break
              default:
              break
            }
          }}
        />
      </div>
      {
        (select === 3)
          ? <SelectCompanie
              data-testid="mail-entreprise"
              value={companie}
              setValue={(value) => dispatch(SET_MAIL('companie', value))}
            />
          : (select === 4)
            ? <InputAutocomplete
                data-testid="mail-salaries"
                value={utilisateurs}
                label="Destinataires"
                onChange={(event, value) => dispatch(SET_MAIL('users', value))}
                options={liste.filter(item => mails.indexOf(item.mail) < 0)}
              />
            : (select === 5)
              ? <InputMail
                  data-testid="mail-adresse"
                  value={mail}
                  setValue={Mail}
                  error={error.mail}
                  onKeyUp={(event) => {
                    if (event.key === 'Enter') {
                      Add()
                    }
                  }}
                />
              : null
      }
    </Paper>
  )
}

export default MailUsers
